<template>
    <div v-if="hasLandlords" class="mt-6 overflow-hidden bg-white shadow sm:rounded-lg dark:bg-gray-800/50 dark:shadow-none dark:ring-1 dark:ring-inset dark:ring-white/10">
        <div class="px-4 py-6 sm:px-6">
            <h3 class="text-base/7 font-semibold text-gray-900 dark:text-white">Reference Authorization</h3>
            <p class="mt-1 max-w-2xl text-sm/6 text-gray-500 dark:text-gray-300">
                Authorize RentRisk to contact the landlords you listed and verify your rental history.
            </p>
        </div>
        <div class="border-t border-gray-100 px-4 py-6 sm:px-6 dark:border-white/5">
            <div class="rounded-lg bg-gray-50 p-4 dark:bg-gray-900/40">
                <p class="text-sm text-gray-700 leading-relaxed dark:text-gray-300">
                    I authorize RentRisk to contact the references I listed and release my rental history information to them for verification purposes.
                </p>
            </div>

            <label class="mt-4 flex items-start space-x-3">
                <input
                    type="checkbox"
                    v-model="form.reference_authorization_agreed"
                    class="mt-1 rounded border-gray-300 text-rent-risk-blue-400 focus:ring-rent-risk-blue-400 h-4 w-4"
                />
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
                    I agree to the reference authorization <span class="text-red-700">*</span>
                </span>
            </label>
            <p v-if="form.errors.reference_authorization_agreed" v-text="form.errors.reference_authorization_agreed" class="mt-2 text-sm text-red-500"></p>

            <div class="mt-6">
                <SignaturePad
                    ref="referenceSignaturePad"
                    label="Authorization Signature"
                    helper-text="Sign to authorize reference verification"
                    :required="true"
                    :error="form.errors.reference_authorization_signature"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SignaturePad from '@/Components/SignaturePad.vue';

export default {
    components: { SignaturePad },
    props: {
        form: { type: Object, required: true },
        validateField: { type: Function, required: true },
    },
    computed: {
        hasLandlords() {
            return this.form.has_current_landlord == 1
                || this.form.has_previous_landlord == 1;
        },
    },
    mounted() {
        if (this.form.reference_authorization_signature) {
            this.$nextTick(() => {
                if (this.$refs.referenceSignaturePad) {
                    this.$refs.referenceSignaturePad.fromDataURL(this.form.reference_authorization_signature);
                }
            });
        }
    },
    methods: {
        validateAuthorization(clearErrors = true) {
            if (!this.hasLandlords) {
                return true;
            }

            if (clearErrors) {
                this.form.clearErrors('reference_authorization_agreed');
                this.form.clearErrors('reference_authorization_signature');
            }

            let hasErrors = false;

            if (!this.form.reference_authorization_agreed) {
                this.form.setError('reference_authorization_agreed', 'You must agree to the reference authorization.');
                hasErrors = true;
            }

            if (this.form.reference_authorization_agreed) {
                if (!this.$refs.referenceSignaturePad || this.$refs.referenceSignaturePad.isEmpty()) {
                    this.form.setError('reference_authorization_signature', 'Reference authorization signature is required.');
                    hasErrors = true;
                } else {
                    this.form.reference_authorization_signature = this.$refs.referenceSignaturePad.save();
                }
            }

            return !hasErrors;
        },
    },
    watch: {
        'form.reference_authorization_signature'(value) {
            if (value && this.$refs.referenceSignaturePad) {
                this.$nextTick(() => {
                    this.$refs.referenceSignaturePad.fromDataURL(value);
                });
            }
        },
    },
};
</script>
